export default __webpack_public_path__ + "static/media/carousel-1-min.5050dc6e.png";